export class SsoIntegrationProfile {
  constructor(
    readonly name: string,
    readonly image: string,
    readonly marketplaceId: string,
    readonly avatarType: 'facility' | 'default',
  ) {}
}
